export const getWebSocketUrl = () => {
  const { location } = window; // eslint-disable-line no-undef
  const { host } = location;
  const protocol = location.protocol === 'https:' ? 'wss:' : 'ws:';

  return `${protocol}//${host}/cable`;
};
